import { RightChevron } from '../../../icons/questionnaire/RightChevron'
import type { GainType } from '../types/summary.types'

type NoTaxSavingsProps = {
  /** Context: LTCG or STCG so the subtitle uses the correct label */
  gainType: GainType
  /** Formatted tax amount (e.g. "₹8,000"). When absent or zero, shows "no tax to pay"; otherwise "liable to pay X" */
  taxLiability?: string
  /** Optional click handler – when provided, the card becomes clickable */
  onClick?: () => void
  /** Controls whether the right chevron is shown; defaults to true */
  showChevron?: boolean
}

function isLiableSubtitle(taxLiability: string | undefined): boolean {
  if (!taxLiability || !taxLiability.trim()) return false
  const normalized = taxLiability.replace(/\s/g, '')
  return normalized !== '₹0' && normalized !== '0' && normalized !== '-₹0'
}

export function NoTaxSavings({ gainType, taxLiability, onClick, showChevron = true }: NoTaxSavingsProps) {
  const gainLabel = gainType
  const subtitle = isLiableSubtitle(taxLiability)
    ? `You are liable to pay ${String(taxLiability).trim()} tax for your ${gainLabel}`
    : `You have no tax to pay on your ${gainLabel}`

  return (
    <div
      className={`rounded-[12px] bg-[#E6F2FF] ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className='px-4 py-3 flex items-center justify-between gap-3'>
        <div>
          <div className='text-sm font-medium text-[#004D99]'>No tax saving opportunity available</div>
          <div className='text-[13px] text-[#004D99] opacity-50'>{subtitle}</div>
        </div>
        {showChevron ? (
          <span aria-hidden className='text-[#004D99]'>
            <RightChevron fill='#004D99' />
          </span>
        ) : null}
      </div>
    </div>
  )
}